<script>
import axios from "axios";
import { InboundOrderPath, WarehousePath, LocationPath } from "@/path.js";
import Swal from "sweetalert2";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
import { GravyPath, PackagingPath } from "@/path.js";
import { VENDORS_PATH } from "../../../../../path";

export default {
  props: ["selectedOrder", "type"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      form: {
        type: null,
        batch_code: null,
        warehouse_id: null,
        vendor_id: null,
        location_id: null,
        production_on: null,
      },
      items: [],
      key: 0,
      type_options: [
        {
          key: "gravies",
          value: "Gravies",
        },
        {
          key: "packagings",
          value: "Packaging",
        },
      ],
      data: [],
      key2: 1,
      filteredData: [],
      filter: [],
      fields: ["name", "actions"],
      current_page: 1,
      f_current_page: 1,
      search: null,
      statuses: [
        {
          key: "pending",
          value: "Pending",
        },
        {
          key: "progress",
          value: "In Progress",
        },
        {
          key: "completed",
          value: "Completed",
        },
      ],
    };
  },
  computed: {
    InboundOrderPath() {
      return InboundOrderPath;
    },
    WarehousePath() {
      return WarehousePath;
    },
    VENDORS_PATH() {
      return VENDORS_PATH;
    },
    LocationPath() {
      return LocationPath;
    },
    GravyPath() {
      return GravyPath;
    },
    PackagingPath() {
      return PackagingPath;
    },
  },
  watch: {
    "form.type"(v) {
      console.log(v);
      this.data = [];
      this.filteredData = [];
      if (v == "gravies") {
        this.getGravies();
      } else {
        this.getPackagings();
      }
    },
    current_page() {
      if (this.form.type == "gravies") {
        this.getGravies();
      } else {
        this.getPackagings();
      }
    },
    search() {
      if (this.form.type == "gravies") {
        this.getGravies();
      } else {
        this.getPackagings();
      }
    },
    // selectedOrder(){
    //     console.log(this.selectedOrder && Object.keys(this.selectedOrder).length > 0);
    //     if(this.selectedOrder && Object.keys(this.selectedOrder).length > 0){
    //         this.form =  {
    //             type : this.selectedOrder.items.filter(f => f.gravy_id != null).length > 0 ? 'gravies' : 'packaging',
    //             batch_code : this.selectedOrder.batch_code,
    //             warehouse_id : this.selectedOrder.warehouse_id,
    //             location_id : this.selectedOrder.location_id,
    //             production_on : this.selectedOrder.production_on,
    //             description : this.selectedOrder.description
    //         }
    //     }
    // }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(
        this.selectedOrder && Object.keys(this.selectedOrder).length > 0
      );
      if (this.selectedOrder && Object.keys(this.selectedOrder).length > 0) {
        this.form = {
          type: this.selectedOrder.gravies > 0 ? "gravies" : "packaging",
          warehouse_id: this.selectedOrder.warehouse_id,
          location_id: this.selectedOrder.location_id,
          vendor_id: this.selectedOrder.vendor_id,
          from_warehouse_id: this.selectedOrder.from_warehouse_id,
          from_location_id: this.selectedOrder.from_location_id,
          production_on: this.selectedOrder.production_date,
          description: this.selectedOrder.description,
        };
        this.getGravyPackagingData();
      } else {
        this.form = {
          type: null,
          batch_code: null,
          warehouse_id: null,
          vendor_id: null,
          location_id: null,
          production_on: null,
        };
      }
    });
  },
  methods: {
    isEmpty(v) {
      if (v != null && v != "") {
        return false;
      }
      return true;
    },
    addItems() {
      this.items.push({
        item_id: null,
      });
    },
    removeItems(i) {
      if (this.selectedOrder && Object.keys(this.selectedOrder).length > 0) {
        this.deleteItem(i);
      }
      this.items.splice(i, 1);
    },
    async deleteItem(i) {
      try {
        let res = await axios.delete(
          this.baseUrl + InboundOrderPath.DELETE_BATCH_CODE,
          {
            params: {
              batch_code: this.items[i].batch_code,
            },
          }
        );
        if (res.data.status) {
          Swal.fire("Deleted Successfully");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getGravyPackagingData() {
      try {
        console.log("hello");
        let res = await axios.get(
          this.baseUrl + InboundOrderPath.GET_BATCH_DETAILS,
          {
            params: {
              date: this.selectedOrder.production_date,
              status: this.selectedOrder.status,
              warehouse: this.selectedOrder.warehouse_id,
              location: this.selectedOrder.location_id,
              unique_batch_id: this.selectedOrder.unique_batch_id,
            },
          }
        );
        if (res.data.status) {
          this.items = res.data.data.map((r) => {
            return {
              id: r.id,
              item_id: r.gravy_id != null ? r.gravy : r.packaging,
              batch_code: r.batch_code,
              uom: r.uom,
              pack_size: r.pack_size,
              unit_price: r.unit_price,
              qty: r.qty,
              best_before_date: r.best_before_date,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectedItem(ii, v) {
      this.items[ii].item_id = v;
      this.generateProductionCode(ii);
    },
    addData(v) {
      this.filteredData.push(v);
    },
    removeItem(v) {
      this.filteredData = this.filteredData.filter((f) => f.id != v.id);
    },
    async validateData() {
      let validated_data = ["warehouse_id", "location_id", "production_on"];
      let items_validate = [];
      if (this.form.type == "gravies") {
        items_validate.push("best_before_date");
      }
      if (this.form.type == "packagings") {
        items_validate.push(
          ...[
            "total_invoice_amount",
            "invoice_number",
            "invoice_date",
            "vendor_batch_code",
            "uom",
            "unit_price",
          ]
        );
      }
      let bool = true;
      this.items.forEach((i) => {
        Object.keys(i).forEach((k) => {
          if (items_validate.includes(k) && this.checkEmpty(i[k])) {
            console.log(k);
            Swal.fire("Please Fill " + k + " Data");
            bool = false;
          }
        });
      });
      Object.keys(this.form).forEach((k) => {
        if (validated_data.includes(k) && this.checkEmpty(this.form[k])) {
          console.log(k);
          Swal.fire("Please Fill " + k + " Data");
          bool = false;
        }
      });
      return bool;
    },
    checkEmpty(v) {
      if (v == null || v == "") {
        return true;
      }
      return false;
    },
    setUnitPrice(i, v) {
      console.log(this.items[i]);
      this.items[i].unit_price = parseFloat(v / this.items[i].qty).toFixed(2);
      this.key2 += 1;
      console.log(this.items[i]);
    },
    async getGravies() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.ALL, {
          params: {
            search: this.search,
            page: this.current_page,
          },
        });
        if (res.data.status) {
          this.data = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    generateProductionCode(ii) {
      console.log(this.form.production_on);
      let currentDateAndTime = new Date();
      const now =
        this.form.production_on != null
          ? new Date(this.form.production_on)
          : new Date();
      // const unixTimestamp = Math.floor(now.getTime() / 1000);
      now.setHours(currentDateAndTime.getHours());
      now.setMinutes(currentDateAndTime.getMinutes());
      now.setSeconds(currentDateAndTime.getSeconds());
      now.setMilliseconds(currentDateAndTime.getMilliseconds());

      const year = now.getFullYear() % 100;
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      // const seconds = String(now.getSeconds()).padStart(2, '0');
      // const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

      const productionCode = `P${this.type == "gravies" ? "G" : "P"}${
        this.items[ii].item_id.id
      }-${year}${month}${day}${hours}${minutes}`;
      this.items[ii].batch_code = productionCode;
    },
    async getPackagings() {
      try {
        let res = await axios.get(this.baseUrl + PackagingPath.ALL, {
          params: {
            search: this.search,
            page: this.current_page,
          },
        });
        if (res.data.status) {
          this.data = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      try {
        let validate = await this.validateData();
        console.log(validate);
        if (!validate) {
          return;
        }
        let res;
        this.form.type = this.type;
        this.form.items = this.items;
        if (this.selectedOrder && Object.keys(this.selectedOrder).length > 0) {
          this.form.order_id = this.selectedOrder.id;
          this.form.unique_batch_id = this.selectedOrder.unique_batch_id;
          res = await axios.post(
            this.baseUrl + InboundOrderPath.UpdateOrder,
            this.form
          );
        } else {
          res = await axios.post(
            this.baseUrl + InboundOrderPath.SaveOrder,
            this.form
          );
        }
        if (res.data.status) {
          Swal.fire("Order Saved Successfully", "", "success");
          this.$bvModal.hide("add");
          this.$emit("done");
        }
      } catch (error) {
        console.log(error);
        Swal.fire("Failed to save Order", "", "error");
      }
    },
    getExtraParams() {
      console.log("&warehouse_id=" + this.form.warehouse_id);
      return "&warehouse_id=" + this.form.warehouse_id;
    },
  },
  components: { SelectWithSearch },
};
</script>

<template>
  <b-card>
    <b-card-header>{{
      selectedOrder && Object.keys(this.selectedOrder).length > 0
        ? "#" + " Production " + this.selectedOrder.production_date
        : "New Batch"
    }}</b-card-header>
    <b-card-body>
      <b-row>
        <!-- <b-col>
                    <label>Batch Type</label>
                    <SelectWithSearch :selected_data="[type]" selected_by="key" :optionsData="type_options" :search_without_api="true" track_by="key" display="value" @selectedOption="((v) => type = v)"></SelectWithSearch>
                </b-col>                 -->
        <b-col sm="4">
          <label>Warehouse</label>
          <SelectWithSearch
            :selected_data="[form.warehouse_id]"
            selected_by="id"
            :search_api="WarehousePath.WAREHOUSE_SEARCH"
            track_by="id"
            display="name"
            @selectedOption="(v) => (form.warehouse_id = v)"
          ></SelectWithSearch>
        </b-col>
        <b-col sm="4">
          <label>Location</label>
          <SelectWithSearch
            v-if="form.warehouse_id"
            :selected_data="[form.location_id]"
            selected_by="id"
            :key="key"
            :search_api="LocationPath.LOCATION_SEARCH"
            track_by="id"
            display="location"
            @selectedOption="(v) => (form.location_id = v)"
            :extra_params="'&warehouse_id=' + form.warehouse_id"
          ></SelectWithSearch>
        </b-col>
        <b-col sm="4">
          <label>Production On / Received On</label>
          <b-datepicker v-model="form.production_on"></b-datepicker>
        </b-col>
        <b-col sm="4">
          <label>Invoice Number</label>
          <b-input v-model="form.invoice_number"></b-input>
        </b-col>
        <b-col sm="4">
          <label>Invoice Date</label>
          <b-datepicker v-model="form.invoice_date"></b-datepicker>
        </b-col>
        <b-col sm="4">
          <label>Vendors</label>
          <SelectWithSearch
            :selected_data="[form.vendor_id]"
            selected_by="id"
            :search_api="VENDORS_PATH.GET"
            extra_params="&no_pagination=true"
            track_by="id"
            display="name"
            @selectedOption="(v) => (form.vendor_id = v)"
          ></SelectWithSearch>
        </b-col>
        <!-- <b-col sm="4">
                    <label>Status</label>
                    <p v-if="!selectedOrder">Pending</p>
                    <SelectWithSearch v-else :optionsData="statuses" :selected_data="[selectedOrder.status]" selected_by="key" :search_without_api="true" track_by="key" display="value" @selectedOption="((v) => form.status=v)"></SelectWithSearch>
                </b-col> -->
        <b-col sm="6">
          <label>Special Instructions</label>
          <b-textarea v-model="form.description"></b-textarea>
        </b-col>
      </b-row>
      <b-button variant="primary" @click="addItems" class="float-right"
        ><i class="fa fa-plus"></i> Add Line Item</b-button
      >
      <div>
        <table class="table">
          <thead>
            <tr>
              <td>Product Id</td>
              <td style="width: 15%">
                {{
                  type ? (type == "gravies" ? "Gravy" : "Packaging") : "-----"
                }}
              </td>
              <td>Batch Code</td>
              <th v-if="type == 'packagings'">Uom</th>
              <!-- <th v-if="type == 'packagings'">Pack Size</th>                             -->
              <th>Qty</th>
              <th v-if="type == 'packagings'">Total Amount</th>
              <th v-if="type == 'packagings'">Unit Price</th>
              <th v-if="type != 'packagings'">Best Before Date</th>
              <td>Actions</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, ii) in items" :key="ii">
              <td>
                {{ i.item_id?.id }}
              </td>
              <td>
                <!-- <p v-if="selectedOrder && Object.keys(selectedOrder).length > 0">{{ i.gravy_name }}</p> -->
                <SelectWithSearch
                  :full_object="true"
                  :selected_data="[i.item_id?.id]"
                  selected_by="id"
                  :search_api="
                    type == 'gravies'
                      ? GravyPath.SEARCH_GRAVIES
                      : PackagingPath.SEARCH_PACKAGING
                  "
                  track_by="id"
                  display="name"
                  @selectedOption="selectedItem(ii, $event)"
                ></SelectWithSearch>
              </td>
              <td>
                {{ i.batch_code }}
              </td>
              <td v-if="type == 'packagings'">
                <b-select :options="['Box', 'Pcs']" v-model="i.uom"></b-select>
              </td>
              <!-- <td v-if="type == 'packagings'">
                                <b-input type="number" v-model="i.pack_size"></b-input>
                            </td> -->
              <td>
                <b-input type="number" v-model="i.qty"></b-input>
              </td>
              <td v-if="type == 'packagings'">
                <b-input
                  type="number"
                  v-model="i.total_amount"
                  @input="setUnitPrice(ii, $event)"
                ></b-input>
              </td>
              <td v-if="type == 'packagings'">
                <b-input type="number" v-model="i.unit_price"></b-input>
              </td>
              <td v-if="type != 'packagings'">
                <b-datepicker v-model="i.best_before_date"></b-datepicker>
              </td>
              <td>
                <b-button
                  variant="primary"
                  @click="addItems"
                  class="float-right"
                  ><i class="fa fa-plus"></i
                ></b-button>
                <b-button variant="danger" @click="removeItems(ii)"
                  ><i class="fa fa-trash"></i
                ></b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-button variant="success" @click="saveOrder">Save</b-button>
    </b-card-body>
  </b-card>
</template>

<style></style>
